(() => {
  const normalize = (value) => String(value || '').trim().toLowerCase();

  const FILTERS = [
    {
      key: 'brainrot',
      menuSelector: '[id^="BrainrotMenu-"]',
      labelSelector: '[id^="BrainrotLabel-"]',
      buttonSelector: '[data-brainrot]',
      defaultLabel: 'Brainrots',
      emptyMessage: 'No brainrots found',
    },
    {
      key: 'mutation',
      menuSelector: '[id^="MutationMenu-"]',
      labelSelector: '[id^="MutationLabel-"]',
      buttonSelector: '[data-mutation]',
      defaultLabel: 'Mutations',
      emptyMessage: 'No mutations found',
    },
    {
      key: 'speed',
      menuSelector: '[id^="SpeedMenu-"]',
      labelSelector: '[id^="SpeedLabel-"]',
      buttonSelector: '[data-speed]',
      defaultLabel: 'M/s',
      emptyMessage: 'No speeds found',
    },
  ];

  const addStyles = () => {
    if (document.getElementById('AdhdbloxInlineFilterSearchStyles')) return;

    const style = document.createElement('style');
    style.id = 'AdhdbloxInlineFilterSearchStyles';
    style.textContent = `
      .adhdblox-filters__menu-search-wrap {
        display: none !important;
      }

      .adhdblox-filters__menu {
        background: #9995D2 !important;
        color: #ffffff !important;
      }

      .adhdblox-filters__menu button {
        color: #ffffff !important;
        background: transparent !important;
      }

      .adhdblox-filters__menu button:hover,
      .adhdblox-filters__menu button:focus-visible {
        background: #8C88C5 !important;
        color: #ffffff !important;
      }

      .adhdblox-filters__menu button[hidden] {
        display: none !important;
      }

      .adhdblox-filters__no-results {
        display: block;
        box-sizing: border-box;
        width: 100%;
        padding: 14px 18px;
        background: #9995D2;
        color: #ffffff;
        font: inherit;
        line-height: 1.35;
        pointer-events: none;
        user-select: none;
      }

      .adhdblox-filters__no-results[hidden] {
        display: none !important;
      }

      @media screen and (min-width: 750px) {
        .adhdblox-filters__select [contenteditable="true"] {
          display: block;
          width: 100%;
          min-width: 0;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: clip;
          color: #ffffff;
          caret-color: #ffffff;
          outline: none;
          cursor: text;
        }
      }
    `;

    document.head.appendChild(style);
  };

  const removeNoneMutationOptions = (filterArea) => {
    filterArea
      .querySelectorAll('[data-mutation], [data-mobile-panel="mutation"] [data-mobile-panel-value]')
      .forEach((button) => {
        const value =
          button.getAttribute('data-mutation') ??
          button.getAttribute('data-mobile-panel-value') ??
          button.textContent;

        if (normalize(value) === 'none') button.remove();
      });
  };

  const removeLegacyDropdownSearch = (filterArea) => {
    filterArea
      .querySelectorAll('.adhdblox-filters__menu-search-wrap')
      .forEach((node) => node.remove());
  };

  const ensureNoResults = (menu, config) => {
    let message = menu.querySelector(
      `.adhdblox-filters__no-results[data-filter-empty="${config.key}"]`
    );

    if (!message) {
      message = document.createElement('div');
      message.className = 'adhdblox-filters__no-results';
      message.dataset.filterEmpty = config.key;
      message.textContent = config.emptyMessage;
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');
      message.hidden = true;
      menu.appendChild(message);
    }

    return message;
  };

  const getVisibleButtons = (menu, selector) =>
    Array.from(menu.querySelectorAll(selector)).filter((button) => !button.hidden);

  const filterMenu = (menu, config, searchValue) => {
    const query = normalize(searchValue);
    const attribute = config.buttonSelector.slice(1, -1);
    let visibleMatches = 0;

    menu.querySelectorAll(config.buttonSelector).forEach((button) => {
      const value = normalize(
        button.getAttribute(attribute) || button.textContent
      );
      const isAllOption = value === '';
      const isVisible = !query || (!isAllOption && value.startsWith(query));

      button.hidden = !isVisible;
      if (isVisible && !isAllOption) visibleMatches += 1;
    });

    const noResults = ensureNoResults(menu, config);
    noResults.hidden = !query || visibleMatches > 0;
  };

  const placeCaretAtEnd = (element) => {
    const range = document.createRange();
    range.selectNodeContents(element);
    range.collapse(false);

    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  };

  const setupFilterArea = (filterArea) => {
    if (filterArea.dataset.inlineFilterSearchBound === 'true') return;
    filterArea.dataset.inlineFilterSearchBound = 'true';

    addStyles();
    removeLegacyDropdownSearch(filterArea);
    removeNoneMutationOptions(filterArea);

    let active = null;

    const closeInlineSearch = (restoreLabel = true) => {
      if (!active) return;

      const current = active;
      active = null;

      current.label.removeAttribute('contenteditable');
      current.label.removeAttribute('role');
      current.label.removeAttribute('aria-label');
      current.label.removeAttribute('spellcheck');

      if (restoreLabel) {
        current.label.textContent =
          current.previousLabel || current.config.defaultLabel;
      }

      filterMenu(current.menu, current.config, '');
      current.menu.hidden = true;
      current.toggle.setAttribute('aria-expanded', 'false');
    };

    FILTERS.forEach((config) => {
      const menu = filterArea.querySelector(config.menuSelector);
      const label = filterArea.querySelector(config.labelSelector);
      const toggle = filterArea.querySelector(`[data-filter-toggle="${config.key}"]`);

      if (!menu || !label || !toggle) return;

      ensureNoResults(menu, config);

      label.addEventListener('click', (event) => {
        if (label.getAttribute('contenteditable') === 'true') {
          event.stopPropagation();
        }
      });

      label.addEventListener('input', () => {
        if (!active || active.label !== label) return;
        filterMenu(menu, config, label.textContent);
      });

      label.addEventListener('paste', (event) => {
        if (label.getAttribute('contenteditable') !== 'true') return;

        event.preventDefault();
        const text = event.clipboardData.getData('text/plain');
        document.execCommand('insertText', false, text);
      });

      label.addEventListener('keydown', (event) => {
        if (label.getAttribute('contenteditable') !== 'true') return;

        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          closeInlineSearch(true);
          return;
        }

        if (event.key === 'Enter') {
          event.preventDefault();
          event.stopPropagation();

          const firstButton = getVisibleButtons(menu, config.buttonSelector)[0];
          firstButton?.click();
          return;
        }

        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          event.stopPropagation();

          const visibleButtons = getVisibleButtons(menu, config.buttonSelector);
          const target =
            event.key === 'ArrowDown'
              ? visibleButtons[0]
              : visibleButtons[visibleButtons.length - 1];

          target?.focus();
        }
      });

      toggle.addEventListener('click', (event) => {
        if (window.matchMedia('(max-width: 749px)').matches) return;
        if (event.target.closest('.adhdblox-filters__clear')) return;

        window.setTimeout(() => {
          if (menu.hidden) return;

          if (active && active.label !== label) closeInlineSearch(true);

          const previousLabel = label.textContent.trim() || config.defaultLabel;

          active = { config, menu, label, toggle, previousLabel };

          label.textContent = '';
          label.setAttribute('contenteditable', 'true');
          label.setAttribute('role', 'textbox');
          label.setAttribute('aria-label', `Search ${config.defaultLabel}`);
          label.setAttribute('spellcheck', 'false');

          filterMenu(menu, config, '');
          label.focus();
          placeCaretAtEnd(label);
        }, 0);
      });

      menu.addEventListener('keydown', (event) => {
        const visibleButtons = getVisibleButtons(menu, config.buttonSelector);
        const currentIndex = visibleButtons.indexOf(document.activeElement);

        if (currentIndex < 0) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          closeInlineSearch(true);
          return;
        }

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          visibleButtons[(currentIndex + 1) % visibleButtons.length]?.focus();
        }

        if (event.key === 'ArrowUp') {
          event.preventDefault();
          visibleButtons[
            (currentIndex - 1 + visibleButtons.length) % visibleButtons.length
          ]?.focus();
        }
      });
    });

    filterArea.addEventListener(
      'click',
      (event) => {
        const selectedOption = event.target.closest(
          '[data-brainrot], [data-mutation], [data-speed]'
        );

        if (selectedOption && active) {
          const current = active;

          window.setTimeout(() => {
            current.label.removeAttribute('contenteditable');
            current.label.removeAttribute('role');
            current.label.removeAttribute('aria-label');
            current.label.removeAttribute('spellcheck');
            filterMenu(current.menu, current.config, '');

            if (active === current) active = null;
          }, 0);
        }

        const desktopBrainrotChoice = event.target.closest('[data-brainrot]');
        const mobileBrainrotChoice = event.target.closest(
          '[data-mobile-panel="brainrot"] [data-mobile-panel-value]'
        );

        if (!desktopBrainrotChoice && !mobileBrainrotChoice) return;

        const searchInput = filterArea.querySelector('.adhdblox-filters__search-input');
        if (!searchInput || !searchInput.value) return;

        searchInput.value = '';
        searchInput.dispatchEvent(new Event('input', { bubbles: true }));
      },
      true
    );

    document.addEventListener('click', (event) => {
      if (
        active &&
        !active.toggle.contains(event.target) &&
        !active.menu.contains(event.target)
      ) {
        closeInlineSearch(true);
      }
    });

    const observer = new MutationObserver(() => {
      removeLegacyDropdownSearch(filterArea);
      removeNoneMutationOptions(filterArea);
      FILTERS.forEach((config) => {
        const menu = filterArea.querySelector(config.menuSelector);
        if (menu) ensureNoResults(menu, config);
      });
    });

    observer.observe(filterArea, { childList: true, subtree: true });
  };

  const setup = () => {
    document.querySelectorAll('.adhdblox-filters').forEach(setupFilterArea);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
